import {
  FileDocIcon,
  FileIcon,
  FileImageIcon,
  FilePdfIcon,
  FileTextIcon,
  FileXlsIcon,
  FileZipIcon,
  type Icon,
} from "@phosphor-icons/react";
import type { DossierFile } from "@/features/dossiers/types";

/** An icon for the kind of file, from its type and else its extension. */
export const fileIcon = (
  file: Pick<DossierFile, "content_type" | "filename">,
): Icon => {
  const type = file.content_type || "";
  const ext = file.filename.split(".").pop()?.toLowerCase() || "";

  if (type === "application/pdf" || ext === "pdf") return FilePdfIcon;
  if (type.startsWith("image/")) return FileImageIcon;
  if (["xls", "xlsx", "csv", "ods"].includes(ext)) return FileXlsIcon;
  if (["doc", "docx", "odt", "rtf"].includes(ext)) return FileDocIcon;
  if (["zip", "rar", "7z", "gz"].includes(ext)) return FileZipIcon;
  if (type.startsWith("text/") || ext === "txt") return FileTextIcon;
  return FileIcon;
};
